var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-root",class:{ gray: _vm.gray }},[(_vm.showHeader)?_c('Header'):_vm._e(),_vm._v(" "),_c('customer-service',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCustomer),expression:"showCustomer"}]}),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.showFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b22cbd04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dynamic.vue
// module id = null
// module chunks = 